import { defineStore } from "pinia";
import { ref } from "vue";

export const useLoadingStore = defineStore("loading", () => {
  const loading = ref(false);

  /**
   * Set the loading state
   * @param {boolean} value - The loading state to set
   */
  function setLoading(value) {
    loading.value = value;
  }

  return { loading, setLoading };
});
